/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationMarkAsReadRequest
 */
export interface NotificationMarkAsReadRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationMarkAsReadRequest
     */
    notificationIds: Array<string>;
}

/**
 * Check if a given object implements the NotificationMarkAsReadRequest interface.
 */
// @ts-ignore
export function instanceOfNotificationMarkAsReadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notificationIds" in value;

    return isInstance;
}

// @ts-ignore
export function NotificationMarkAsReadRequestFromJSON(json: any): NotificationMarkAsReadRequest {
    return NotificationMarkAsReadRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function NotificationMarkAsReadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMarkAsReadRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notificationIds': json['notification_ids'],
    };
}

// @ts-ignore
export function NotificationMarkAsReadRequestToJSON(value?: NotificationMarkAsReadRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notification_ids': value.notificationIds,
    };
}

